document.addEventListener('DOMContentLoaded', () => {
  exampleWidget();
});

function exampleWidget() {
  document.querySelectorAll('.js-example-widget').forEach((element) => {
    console.log(element);
  });
}
